<template>
  <div>
    <div v-text="title" class="title"></div>

    <v-card outlined>
      <v-simple-table :class="[$globalStyle['cross-row']]">
        <tbody>
          <template v-for="(item) in format">
            <tr :key="`${item.key}-name`" class="cyan lighten-5">
              <td v-text="item.name" class="text-center subtitle-1"></td>
            </tr>
            <template v-if="item.type === 'textField'">
              <tr v-for="rowIndex in item.rowLength" :key="`${item.key}-${rowIndex}`">
                <td>
                  <v-text-field
                    :prefix="`${rowIndex}.`"
                    dense
                    outlined
                    v-model="conData[item.key][rowIndex-1]"
                    :value="conData[item.key][rowIndex-1]"
                    :error-messages="
                         conData[item.key][rowIndex-1] && conData[item.key][rowIndex-1].length > item.wordLength
                            ? `字數超過${item.wordLength}個字元限制`
                            : ''
                        "
                    :hide-details="!conData[item.key][rowIndex-1] || conData[item.key][rowIndex-1].length <= item.wordLength"
                  ></v-text-field>
                </td>
              </tr>
            </template>
            <template v-if="item.type === 'textArea'">
              <tr :key="`${item.key}-textArea`">
                <td>
                  <v-textarea
                    outlined
                    hide-details
                    rows="20"
                    class="my-1"
                    v-model="conData[item.key]"
                    :value="conData[item.key]"
                  ></v-textarea>
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </v-simple-table>
    </v-card>
  </div>
</template>
<script>
export default {
  props: ["title", "format", "data"],
  data: thisVm => ({
    conData: thisVm.data
  }),
  methods: {
    setConData(data) {
      console.log("data:" + JSON.stringify(data));
      this.conData = data;
    },
    getConData() {
      let thisVm = this;
      Object.keys(thisVm.conData).forEach(key => {
        if (Array.isArray(thisVm.conData[key])) {
          thisVm.conData[key] = thisVm.conData[key].filter(data => {
            return data;
          });
        }
      });
      return thisVm.conData;
    }
  }
};
</script>